import { useEffect, useRef } from "react"

const DesktopVersionView = ({ url, height = '100vh' }) => {

  const iframeRef = useRef(null)
  useEffect(() => {
    const disableInteractions = () => {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        const iframeDoc = iframeRef.current.contentWindow.document

        if (iframeDoc && iframeDoc.body) {
          iframeDoc.body.style.pointerEvents = "none"
          iframeDoc.body.style.overflow = "auto"
        }
      }
    }

    const iframe = iframeRef.current
    if (iframe) {
      iframe.onload = () => {
        disableInteractions()
      }
    }

    const interval = setInterval(() => {
      disableInteractions()
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <iframe
      ref={iframeRef}
      id="themePreview"
      title="Theme Preview"
      src={url}
      style={{
        width: "100%",
        height,
        border: "none",
      }}
    />
  )
}

export default DesktopVersionView
